export const APP_ROUTES = {
    App: '',
    Home: 'home',
    Auth: 'auth',
    Unauthorized: '401',
    NotFound: '404',
};
